import React from "react";
import { useIntl } from "react-intl";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";

import List from "../../components/list/List";
import Popup, { PopupContext } from "../../components/popup/Popup";
import useErrorAlert from "../../hooks/useErrorAlert";
import { useDeviceGroupStore } from "../../store/device-group/DeviceGroupStore";
import { useLoading } from "../../store/loading/LoadingContextStore";

import DeviceInterface from "../../interfaces/DeviceInterface";
import GroupInterface from "../../interfaces/GroupInterface";
import CustomError from "../../service/errors/custom.error";

import { MainPageOutletContext } from "../main/Main";
import "./device.scss";

function DeviceList({
  group,
  otherDevices,
  saveDeviceGroup,
}: {
  group: GroupInterface;
  otherDevices: DeviceInterface[];
  saveDeviceGroup: Function;
}) {
  const showErrorAlert = useErrorAlert();
  const processingAsyncFn = useLoading();

  const { close } = React.useContext(PopupContext);

  return (
    <List
      list={otherDevices.map(({ id, type, name, serialNumber }) => ({
        title: name ?? serialNumber,
        onClick: async () => {
          try {
            await processingAsyncFn(() => saveDeviceGroup(id, type, group.id));
            close();
          } catch (e) {
            console.error("Error when saving a device group", e);
            await showErrorAlert(
              e instanceof CustomError ? e.getStatusText() : undefined
            );
          }
        },
      }))}
    />
  );
}

function AddGroupDevicePopup() {
  const navigate = useNavigate();
  const { formatMessage } = useIntl();
  const outlet = useOutletContext<MainPageOutletContext>();

  const { deviceStore, findGroupById, saveDeviceGroup } = useDeviceGroupStore();

  const { groupId } = useParams();
  const group = groupId ? findGroupById(groupId) : undefined;

  const otherDevices = React.useMemo(
    () => deviceStore.filter((d) => d.groupId == null),
    [deviceStore]
  );

  if (groupId != null && group == null) return null;

  return (
    <Popup
      title={formatMessage({ id: "group.create_device.title" })}
      className="create-device-popup"
      close={() => navigate(outlet.baseUrl)}
    >
      <DeviceList
        group={group}
        otherDevices={otherDevices}
        saveDeviceGroup={saveDeviceGroup}
      />
    </Popup>
  );
}

export default AddGroupDevicePopup;
